import { AuthToken, cache, ZomentumStorageKeys } from "@/Contracts";

type AccessTokenGetter = () => Promise<string>;

let registeredGetter: AccessTokenGetter | null = null;

export const registerAccessTokenRefresher = (
	getAccessToken: AccessTokenGetter
): (() => void) => {
	registeredGetter = getAccessToken;
	return () => {
		if (registeredGetter === getAccessToken) {
			registeredGetter = null;
		}
	};
};

export const refreshAccessToken = async (): Promise<boolean> => {
	if (!registeredGetter) {
		return false;
	}
	try {
		const token = await registeredGetter();
		if (!token) {
			return false;
		}
		cache.save(ZomentumStorageKeys.Token, new AuthToken(token));
		return true;
	} catch (error) {
		console.warn(error);
		return false;
	}
};
